import {styled} from "@mui/material/styles"
import Grid from "@mui/material/Grid"
import {breakpoints} from "@next/ux-fabric"
import {XXL_BREAKPOINT_MAX} from "../../../../config/constants"

export const AutocompleteContent = styled("div")`
    width: 100%;
    ul {
        @media (min-width: ${breakpoints.values.sm}px) and (max-width: ${breakpoints.values.md - 1}px) {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;

            li {
                flex-basis: calc(100% / 2);
                padding-right: 1rem;
            }
        }
    }
`
export const AutocompleteGrid = styled(Grid)`
    border-bottom: 0.0625rem solid ${({theme}) => theme.uxfabric.components.menu.searchMenu.default.borderColor};
    padding-bottom: 1rem;

    @media (min-width: ${breakpoints.values.md}px) {
        border-bottom: 0;
        padding-bottom: 0rem;

        border-right: 0.0625rem solid ${({theme}) => theme.uxfabric.components.menu.searchMenu.default.borderColor};
        flex-grow: 0;
        max-width: 33.333333%;
        flex-basis: 33.333333%;
    }
`

export const AutocompleteProductsGrid = styled(Grid)`
    width: 100%;
    padding-top: 1rem;
    min-height: 300px;
    @media (min-width: ${breakpoints.values.md}px) {
        padding-top: 0;
        padding-left: 1rem;
    }
`

export const StyledContainer = styled("div", {
    shouldForwardProp: prop => prop !== "xxlBreakpointEnabled",
})<{xxlBreakpointEnabled?: boolean}>`
    max-width: ${breakpoints.values.xl}px;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: auto;

    @media (min-width: ${breakpoints.values.md}px) {
        flex-direction: row;
    }

    ${({xxlBreakpointEnabled}) =>
        xxlBreakpointEnabled
            ? `@media (min-width: ${breakpoints.values.xxl}px) {
            max-width: ${XXL_BREAKPOINT_MAX}px;
        }`
            : `@media (min-width: ${breakpoints.values.xl}px) {
            max-width: ${breakpoints.values.xl}px;
        }`}
`
